import React from "react";
import {
  CheckOutlined,
  DoubleRightOutlined,
  EyeOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./home.css";
import {
  Avatar,
  Col,
  Flex,
  Row,
  Card,
  Button,
  Rate,
  Tag,
  Carousel,
  Image,
  Space,
  Typography,
  Divider,
} from "antd";

import { ReactComponent as Visa } from "../assets/images/visa.svg";
import { ReactComponent as Hotel } from "../assets/images/hotel.svg";
import { ReactComponent as BreakFast } from "../assets/images/breakFast.svg";
import { ReactComponent as Transport } from "../assets/images/transport.svg";
import { Input } from "antd";
import activitiesImg from "../assets/images/activities.jpg";
import crazyDealImg from "../assets/images/crazyDeals.jpg";
import hotelImg from "../assets/images/hotel.jpg";
import holidayImg from "../assets/images/holiday.jpg";
import visaImg from "../assets/images/visa.jpg";
import cruiseImg from "../assets/images/cruise.jpg";
import spatialImg from "../assets/images/spe-1.jpg";
import spatialTowImg from "../assets/images/spe-2.jpg";
import spatialThreeImg from "../assets/images/spe-3.jpg";
import exploreCountryImg from "../assets/images/ex-country-1.jpg";
import exploreCountryTwoImg from "../assets/images/ex-country-2.jpg";
import exploreCountryThreeImg from "../assets/images/ex-country-3.jpg";
import sliderImg from "../assets/images/slider-1.jpg";
import { ReactComponent as CheckOutlinedCustom } from "../assets/images/checkbox-icon.svg";
import { ReactComponent as Accommodation } from "../assets/images/accommodation.svg";
import { ReactComponent as AllMeals } from "../assets/images/all-meals.svg";
import { ReactComponent as OnTourTransport } from "../assets/images/On-tour transport.svg";
import { ReactComponent as BestValueItinerary } from "../assets/images/best-value-itinerary.svg";
import { ReactComponent as TourManagers } from "../assets/images/tour-managers.svg";
import verifyIcon from "../assets/images/verify.svg";
import discountIcon from "../assets/images/discount.svg";
import { ReactComponent as HotelIcon } from "../assets/images/hotel.svg";
import { ReactComponent as TransportIcon } from "../assets/images/transport.svg";
import { ReactComponent as BreakFastIcon } from "../assets/images/breakFast.svg";
import { ReactComponent as KidsClubsIcon } from "../assets/images/kidsClubs.svg";
import { ReactComponent as FitnessIcon } from "../assets/images/fitness.svg";
import { ReactComponent as SwimmingPool } from "../assets/images/swimmingPool.svg";
import { ReactComponent as TheaterIcon } from "../assets/images/theater.svg";
import cruiseDetail from "../assets/images/cruiseDetail.jpg";
import cruisePoints from "../assets/images/cruisePoints.jpg";


import {
  GiftOutlined,
  DollarOutlined,
  HomeOutlined,
  CompassOutlined,
  FileDoneOutlined,
  RocketOutlined,
} from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import MegaMenu from "../components/MegaMenu";
import TravelBanner from "../components/TravelBanner";
import ItineraryViewer from "../components/ItineraryData";
import GalleryGrid from "../components/GalleryGrid";
import BookingSummary from "../components/BookingSummary";
import TourInclusionsTabs from "../components/TourInclusionsTabs";
import ReviewSlider from "../components/ReviewSlider";
import CruiseRoomCard from "../components/CruiseRoomCard";

const { Text, Paragraph } = Typography;
const categories = [
  {
    title: "Activities",
    desc: "your wanderlust awaits!",
    icon: <GiftOutlined />,
    img: activitiesImg,
  },
  {
    title: "Crazy Deals",
    desc: "Deal on Hotel and Flights",
    icon: <DollarOutlined />,
    img: crazyDealImg,
  },
  {
    title: "Hotel",
    desc: "your wanderlust awaits!",
    icon: <HomeOutlined />,
    img: hotelImg,
  },
  {
    title: "Holiday",
    desc: "your wanderlust awaits!",
    icon: <CompassOutlined />,
    img: holidayImg,
  },
  {
    title: "Visa",
    desc: "your wanderlust awaits!",
    icon: <FileDoneOutlined />,
    img: visaImg,
  },
  {
    title: "Cruise",
    desc: "your wanderlust awaits!",
    icon: <RocketOutlined />,
    img: cruiseImg,
  },
];

const offers = [
  {
    img: spatialImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
  {
    img: spatialTowImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
  {
    img: spatialThreeImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
];

const tours = [
  {
    id: 1,
    image: exploreCountryImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Standard",
    tagColor: "blue",
    badgeColor: "#10239E",
  },
  {
    id: 2,
    image: exploreCountryTwoImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Premium",
    tagColor: "gold",
    badgeColor: "#D72638",
  },
  {
    id: 3,
    image: exploreCountryThreeImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Value",
    tagColor: "green",
    badgeColor: "#D72638",
  },
];

const highlights = [
  "Singapore and Bali Honeymoon Bliss | City Romance to Tropical Retreat",
  "Best Of Singapore | FREE Universal Studio Tickets Singapore & Malaysia Trip | FREE Night Safari Experience",
];

const toursForYou = [
  {
    title: "Best Selling UAE Tours",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "International Tourist Visas",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Trending Destinations",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Trending Cruise Destinations",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Best Selling Singapore Tours",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
];

const inclusiveTours = [
  {
    icon: <Accommodation />,
    title: "Accommodation",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <AllMeals />,
    title: "All meals",
    description: "Eat to your heart's content Breakfast. Lunch. Dinner.",
  },
  {
    icon: <OnTourTransport />,
    title: "On-tour transport",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <BestValueItinerary />,
    title: "Best value itinerary",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <TourManagers />,
    title: "Tour managers",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
];

const { Search } = Input;
const CruiseDetailPage = () => {
  const itinerary = [
    { days: 1, city: "Dubai", time: "Night" },
    { days: 3, city: "Abu Dhabi", time: "Days" },
    { days: 1, city: "Ras al-Khaimah", time: "Night" },
    { days: 1, city: "QATAR Doha", time: "Night" },
    { days: 1, city: "Oman Khasab", time: "Night" },
  ];
  const highlights = [
    "Set sail on an elegant adventure across the Arabian Gulf, starting with a magical evening arrival in Abu Dhabi, where the city lights shimmer beneath the stars. On Thursday, explore the unspoiled beauty of Sir Bani Yas Island, then spend two exciting days soaking in the dynamic energy of Dubai. Continue your journey with fascinating stops —bringing home treasured memories from a truly remarkable voyage.",
  ];
  return (
    <>
      <section className="lg:min-h-[570px] text-white">
        <TravelBanner></TravelBanner>
      </section>

      <section className="py-6">
        <div className="container">
          <Row gutter={30}>
            <Col xs={17}>
              <Flex
                align="center"
                className="mt-8 mb-2 text-muted text-sm font-medium"
              >
                <Flex align="center">
                  <Tag className="px-4 py-1 border border-[#0389FF] bg-blue-100 text-[#3F6385] font-medium rounded text-sm ml-2">
                    CUSTOMIZED HOLIDAYS
                  </Tag>
                  <img
                    className="!ml-[-20px] relative"
                    preview={false}
                    src={verifyIcon}
                  />
                </Flex>
              </Flex>
              <Flex className="mt-8" align="center" gap={15}>
                <Tag className="px-6 py-2  bg-danger text-white font-medium rounded text-sm ml-2">
                  9 D 3 Countries 5 Cities
                </Tag>
                <div className="flex items-center justify-center">
                  {itinerary.map((item, index) => (
                    <div key={index} className="flex items-center">
                      {/* Stop */}
                      <div className="flex flex-col items-center">
                        <Flex align="center" gap={2}>
                          <Text className="text-[#C4BFBF] font-extrabold text-5xl leading-[48px]">
                            {item.days}
                          </Text>
                          <Flex vertical>
                            <Text className="!text-xs  leading-none">Days</Text>
                            <Text className="!text-sm !font-medium text-danger leading-none">
                              {item.city}
                            </Text>
                          </Flex>
                        </Flex>
                      </div>

                      {/* Arrow except last */}
                      {index < itinerary.length - 1 && (
                        <span className="mx-3 text-gray-400">→</span>
                      )}
                    </div>
                  ))}
                </div>
              </Flex>
              <Divider />
              <Title className="!text-lg !font-medium">Trip Highlights</Title>
              <ul className="list-disc list-outside space-y-2  leading-relaxed">
                {highlights.map((point, index) => (
                  <Paragraph className="font-medium">{point}</Paragraph>
                ))}
              </ul>
              <Flex gap={40} className="iconGroup py-6">
                <Flex align="center" vertical gap={8}>
                  <Avatar
                    className="bg-danger shadow-custom"
                    size={64}
                    icon={<HotelIcon />}
                  />
                  <Paragraph>Hotel</Paragraph>
                </Flex>
                <Flex align="center" vertical gap={8}>
                  <Avatar
                    className="bg-danger shadow-custom"
                    size={64}
                    icon={<TransportIcon />}
                  />
                  <Paragraph>TRANSPORT</Paragraph>
                </Flex>
                <Flex align="center" vertical gap={8}>
                  <Avatar
                    className="bg-danger shadow-custom"
                    size={64}
                    icon={<BreakFastIcon />}
                  />
                  <Paragraph> BREAKFAST</Paragraph>
                </Flex>
                <Flex align="center" vertical gap={8}>
                  <Avatar
                    className="bg-danger shadow-custom"
                    size={64}
                    icon={<KidsClubsIcon />}
                  />
                  <Paragraph>Kids Clubs </Paragraph>
                </Flex>
                <Flex align="center" vertical gap={8}>
                  <Avatar
                    className="bg-danger shadow-custom whiteNoneColorIcon"
                    size={64}
                    icon={<FitnessIcon />}
                  />
                  <Paragraph>Fitness </Paragraph>
                </Flex>
                <Flex align="center" vertical gap={8}>
                  <Avatar
                    className="bg-danger shadow-custom whiteNoneColorIcon"
                    size={64}
                    icon={<SwimmingPool />}
                  />
                  <Paragraph> Swimming Pool</Paragraph>
                </Flex>
                <Flex align="center" vertical gap={8}>
                  <Avatar
                    className="bg-danger shadow-custom whiteNoneColorIcon"
                    size={64}
                    icon={<TheaterIcon />}
                  />
                  <Paragraph> Theater</Paragraph>
                </Flex>
              </Flex>

              <div className="">
                <CruiseRoomCard
                  image={cruiseDetail}
                  title="INTERIOR"
                  price="1,932.70"
                />
                <CruiseRoomCard
                  image={cruisePoints}
                  title="OCEAN VIEW"
                  price="2,461.80"
                  isHighlighted={true}
                />
                <CruiseRoomCard
                  image={cruisePoints}
                  title="BALCONY"
                  price="2,868.80"
                />
              </div>

              <ItineraryViewer />
            </Col>
            <Col xs={7}>
              <GalleryGrid />
              <BookingSummary />

              {/* Cards */}
              <h4 className="mt-11 mb-3 flex items-center gap-2 font-medium text-base ">
                {" "}
                <Image src={discountIcon} /> Spatial Offers
              </h4>
              <Row gutter={[16, 16]} className="flex flex-col" vertical>
                {offers.map((offer, index) => (
                  <Col xs={24} sm={12} md={8} lg={24} key={index}>
                    <Card
                      className="flex rounded-[20px] overflow-hidden border-[#E5E5E5]"
                      styles={{
                        body: {
                          padding: "0px",
                          flex: "1",
                        },
                      }}
                    >
                      <div className="flex">
                        {/* Left image with half-oval */}
                        <div className="relative w-[45%] overflow-hidden rounded-r-full">
                          <div className="absolute overflow-hidden rounded-r-full bg-black/10 w-[95%] h-[100%] "></div>
                          <img
                            src={offer.img}
                            alt={offer.title}
                            className="w-full h-full object-cover"
                          />
                        </div>

                        {/* Right content */}
                        <div className="w-[55%] p-5 pl-4 pr-2 flex flex-col justify-center">
                          <h3 className="text-base mb-2 font-medium">
                            {offer.title}
                          </h3>
                          <p className="text-[9px] mb-4 font-normal">
                            {offer.desc}
                          </p>
                          <small className="text-[9px] mb-1 font-medium">
                            {offer.note}
                          </small>
                          <Button
                            type="danger"
                            size="middle"
                            className="px-6 mt-2 text-[11px] rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md px-4 py-1 text-white w-fit"
                          >
                            View Details
                          </Button>
                        </div>
                      </div>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </div>
      </section>

      <section className="py-6">
        <TourInclusionsTabs />
      </section>
      <section className="py-6">
        <ReviewSlider />
      </section>

      <section className="py-6">
        <div className="container">
          {/* Title */}
          <div className="flex justify-center text-center items-center mb-6">
            <div>
              <h2 className="text-3xl font-normal text-primary">
                Similar Tours{" "}
                <span className="text-danger">
                  tricks and a whole lot more...
                </span>
              </h2>
              <p className="font-normal mt-1">
                Culture, nature, thrills, and record-breaking experiences
              </p>
            </div>
          </div>

          {/* Cards Row */}
          <Row gutter={[40, 16]}>
            {tours.map((tour, index) => (
              <Col xs={24} md={8} key={index}>
                <div className="bg-white rounded-xl overflow-hidden relative shadow-custom hover:shadow-2xl">
                  {/* Image */}
                  <div className="relative">
                    <div className="absolute overflow-hidden bg-black/20 w-full h-[100%] ">
                      <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
                        <div className="text-xl font-semibold text-white">
                          INR 1,43,200
                          <span className="line-through font-normal text-base ml-2">
                            INR 2,65,185
                          </span>
                        </div>
                        <div className="font-normal mt-1 text-white text-xs">
                          SAVE INR 1,21,985
                        </div>
                      </div>
                    </div>
                    <img
                      src={tour.image}
                      alt="Tour"
                      className="w-full h-[203px] object-cover"
                    />
                    {/* Rating Badge */}
                    <div
                      className={`bg-primary absolute bottom-[-25px] right-6 rounded-full shadow-lg text-white text-sm flex  justify-center w-[80px] h-[80px] ${tour.badgeColor}`}
                    >
                      <div className="text-center leading-tight mt-2">
                        <div className="text-3xl">★</div>
                        <div className="text-xs font-normal">4.9 (523)</div>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5 pt-3">
                    {/* <div class="pt-3 bg-gray-100">This will have visible top padding</div> */}
                    <div className="mt-3 mb-2 text-muted text-[11px] font-medium">
                      Tour Type
                      <Tag className="bg-blue-100 text-black font-medium rounded border-0 text-[11px] ml-2">
                        {tour.type}
                      </Tag>
                    </div>

                    <div className="font-medium text-black text-lg leading-snug">
                      Best of Switzerland & Italy with <br />
                      FREE Excursion to Mount Titlis
                    </div>

                    <div className="text-primary mt-4 font-medium">
                      9 days & 8 nights
                    </div>

                    <div className="text-xs text-muted mt-1 space-x-1 font-medium">
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Rome →
                      <span className="text-red-500 font-semibold">1D</span>{" "}
                      Florence →{" "}
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Venice →{" "}
                      <span className="text-red-500 font-semibold">4D</span>{" "}
                      Zurich
                    </div>

                    {/* Buttons */}
                    <div className="flex mt-6 gap-3">
                      <Button
                        type="danger"
                        size="middle"
                        icon={<EyeOutlined className="text-xl" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md px-4 py-1 text-white w-fit"
                      >
                        View Details
                      </Button>
                      <Button
                        size="middle"
                        type="default"
                        icon={<PhoneOutlined className="text-xl rotate-90" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] border-gray-400 text-gray-500 px-6 py-2 rounded-lg"
                      >
                        Call US
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </>
  );
};

export default CruiseDetailPage;
